import { render } from "./ManageMergesModal.vue?vue&type=template&id=4cbf591e&scoped=true"
import script from "./ManageMergesModal.vue?vue&type=script&lang=js"
export * from "./ManageMergesModal.vue?vue&type=script&lang=js"

import "./ManageMergesModal.vue?vue&type=style&index=0&id=4cbf591e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbf591e"]])

export default __exports__